import { render, staticRenderFns } from "./aiWarnList.vue?vue&type=template&id=73848de6&"
import script from "./aiWarnList.vue?vue&type=script&lang=js&"
export * from "./aiWarnList.vue?vue&type=script&lang=js&"
import style0 from "./aiWarnList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports